// extracted by mini-css-extract-plugin
export default {"wrapperChip":"Tag_wrapperChip__6OwXt"};